// extracted by mini-css-extract-plugin
export var link = "Card-module--link--ZG5IM";
export var spinAround = "Card-module--spinAround--1m84u";